import React from 'react';

const PageContainer = ({ children }) => {
    return <div style={{ padding: '116px 0' }}>{children}</div>;
};

export default React.memo(PageContainer);
